<paedml-time-picker>
    <div class="form-group" title={opts.title || opts.placeholder || opts.label}>
        <label if="{opts.label}">{opts.label}</label>
        <input 
            ref="tpicker"
            type="text" 
            id="{inputid}-tpicker"
            name="{opts.name}"
            required={isRequired()}
            placeholder="{opts.placeholder}"
            class="form-control {opts.small ? 'form-control-sm' : ''} {getClassRequired()}"
            data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"
        />
    </div>

<script>
    import * as R from 'ramda'
    import { genDocId } from '../../util/crypto-util'
    import * as i18n from '../../config/i18n/german'
    import moment from 'moment'
    import InputMask from 'inputmask'

    moment.locale('de')
    DateTime.use(moment);

    this.inputid = genDocId();
    this.hasBooleanAttr = attrName => () => this.opts[attrName] !== undefined && this.opts[attrName] !== false
    this.isRequired = this.hasBooleanAttr('required')

    this.getClassRequired = () => this.isRequired() ? 'paedml-input-required' : ''
        
    this.handleChange = this.opts.handlechange
    this.allowpasttimes = this.opts.allowpasttimes
    
    this.getTimePicker = () => this.timepicker

    this.getAvailableHours = () => {
        if(this.allowpasttimes){
            return null
        }
        let hours = []
        var currentHour = new Date().getHours()
        for(let h = ++currentHour; h < 24; h++) {
            hours.push(h)
        }
        return hours
    }

    this.updateData = () => {
        const data = $(this.root).data()
        const inp = $(this.refs.tpicker)
        R.forEachObjIndexed((value, key) => {
            inp.data(key, value)
        }, data)
    }

    this.on('mount', function() {
        const timePickerElement = document.getElementById(this.inputid + '-tpicker');
        this.updateData()
        var self = this

        const timePickerProperties = {
            locale: 'de',
            i18n: i18n.datetimepicker,
            format: 'HH:mm',
            hoursAvailable: self.getAvailableHours(),
            onChange: (value, time, input) => {
                self.handleTimeChange(value, time, input)
            }
        }

       InputMask({
            showMaskOnHover: false,
            showMaskOnFocus: false,
            clearMaskOnLostFocus: false,
            clearIncomplete: false,
                oncomplete: () => {
                    self.maskChanged($('#'+self.inputid+'-tpicker').val())
                },
                oncleared: function(){
                    self.maskChanged('')
                }
            }).mask(timePickerElement)
            
        this.timepicker = new DateTime(timePickerElement, timePickerProperties)
        
    })

    this.maskChanged = (value) => {
        if(value === '') {
            return
        }

        if(!this.isSelectedTimeValid(value)) {
            value = moment().format('HH:mm')  
        }

        let time = moment(value, 'HH:mm').format()  

        this.timepicker.val(value)
        this.handleTimeChange(value, time, this)
    }

    this.isSelectedTimeValid = (value) => {
       
        if(this.allowpasttimes) {
            return true;
        }
        
        let time = moment(value, 'HH:mm')
        var isValid = moment().isBefore(time)
        return isValid
    }

    this.handleTimeChange = (value, time, input) => {
        this.handleAndNotify(time, input)
    }

    this.handleAndNotify = (val, e) => {
        if (this.handleChange) {
           this.handleChange(val, this, e)
        } 
    }
    
</script>

</paedml-time-picker>
